export default {
    title: "Horário de Envio de Notificações",
    success_update: "Atualizado com sucesso",
    copy_instruction:
        "Selecione os dias que receberão a agenda copiada anteriormente",
    main_description:
        "Defina os horários para envio de notificações de acordo com os dias da semana, bem como os horários relativos ao funcionamento e/ou atendimento do estabelecimento",
    all: "Todos",
    copy: "Copiar",
    cancel: "Cancelar",
    save: "Salvar",
    success_copy: "Copiado com sucesso!",
    error_save: "Erro ao tentar salvar os dados de agendamento.",
    success_paste: "Colado com sucesso!",
    browser_title: "Kevi | Horários de Envio de Automações",
    unavailable: "Indisponível",
    add: "Adicionar",
    remove: "Remover",
    days: {
        sunday: "Domingo",
        monday: "Segunda",
        tuesday: "Terça",
        wednesday: "Quarta",
        thursday: "Quinta",
        friday: "Sexta",
        saturday: "Sábado",
    },
};
